import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function ProstateDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Prostate Disorder Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide the exact diagnosis:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.exactDiagnosis.referToAttachments}>
                        <p>{questions.exactDiagnosis.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please confirm the date of diagnosis and presenting symptoms:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosisDetails.referToAttachments}>
                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosisDetails.subQuestions.dateOfDiagnosis)}</p>

                        <Question>Presenting symptoms:</Question>
                        <p>{questions.diagnosisDetails.subQuestions.presentingSymptoms}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide the date and results of any investigations & date/result of most recent PSA:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <br />
                        <Question>Investigations:</Question>
                        <OutputDetails
                            details={questions.investigations.details}
                        />

                        <Question>Most recent PSA:</Question>
                        <OutputDetails
                            details={questions.investigations.mostRecentPsa}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Has malignancy been excluded or underlying cause established?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyUnderlyingCause.referToAttachments}>
                        <p>{questions.anyUnderlyingCause.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Please provide details of treatment and the response to this treatment:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <p>{questions.treatmentProvided.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Please provide details of any ongoing symptoms, including whether they are worsening/increasing or improving/decreasing:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.ongoingSymptoms.referToAttachments}>
                        <p>{questions.ongoingSymptoms.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}